import AirportLayer  from './AirportLayer';
import AircraftLayer from './AircraftLayer'
import AirspaceLayer from './AirspaceLayer';
import AircraftTrack from './AircraftTrack';
import { AirspaceType, IcaoClass } from '../tools/Airspaces';

export default class MapController {

    constructor() {
        this.googleMapsKey = 'AIzaSyBhX_-fDrkR50S9cWX3W2442im84FHsXGs';
        this.mapSettings = {
            zoom: 12,
            center: { lat: 40.5, lng: -5 }, // default location Paris
            minZoom: 2,
            maxZoom: 18,
            panControl: false,
            mapTypeControl: false,
            disableDefaultUI: true,
            streetViewControl: false,
            mapTypeId: 'terrain',
            gestureHandling: 'greedy',
            backgroundColor: "#B3B3B3",
        };
        this.frame = null; // gmaps bounds
        this.planes = null; // json from server
        this.airports = null; // json from server
        this.autocenter = false;
        this.icon_center = null;
        this.cancelUpdate = false;
        this.center_coord = null;
        this.planeMarkers = [];
        this.displaycenter = true;
        this.airportMarkers = [];
        this.autorefresh_timer = 0;
        this.autorefresh_seconds = 5;
        this.timestamp_load_airspaces = 0;

        this.mapOpts = {
            mapTypeId: 'terrain',
            language: 'en', // TODO Not used at the moment
            labelType: 'RSA',
            zoom: 12,
            center: { lat: 40.5, lng: -5 },
            showAircraft: true,
            showAirports: true,
            showAircraftOnGround: true,
            showClassA: false,
            showClassB: false,
            showClassC: false,
            showClassD: false,
            showDanger: false,
            showRestricted: false,
            showProhibited: false,
        };
        this.init();
    }

    init() {
        // If google exists load the object
        if (window.google) {

            this.getMapOptsFromLocalStorage();
            this.onCreateGoogleMapsObject();
            return;
        }

        // Load Google maps script
        this.addGoogleMapsScriptAndCreateObject();
    }

    async loadAirspaces() {
        let date = new Date();
        this.timestamp_load_airspaces = date.getTime();

        const frame = MapController.getFrameTxt(this.map);
        const zoom = this.map.getZoom();
        const airspaces = await AirspaceLayer.loadAirspaces(frame, zoom);
        this.setAirspacesInClass(airspaces);
        return;
    }

    addGoogleMapsScriptAndCreateObject() {
        let s = document.createElement('script');
        let x = document.getElementsByTagName('script')[0];
        
        s.type = 'text/javascript';
        s.src  = 'https://maps.google.com/maps/api/js?key=' + this.googleMapsKey;
        
        x.parentNode.insertBefore(s, x);
        
        s.addEventListener('load', e => {
            this.onCreateGoogleMapsObject();
        });
    }

    onCreateGoogleMapsObject() {
        // Get local storage information
        // Create the google maps object in the #map div
        this.getMapOptsFromLocalStorage();

        this.mapSettings.zoom = this.mapOpts.zoom;
        this.mapSettings.center = this.mapOpts.center;
        this.mapSettings.mapTypeId = this.mapOpts.mapTypeId;

        this.map = new window.google.maps.Map(document.getElementById('map'), this.mapSettings);

        // Add the layers
        new AirportLayer (this.map);
        new AircraftLayer(this.map);
        new AircraftTrack(this.map);

        //let airspaceLayer = new AirspaceLayer(this.map);
        this.airspaceInit();

        // Attach idle to save info to local storage
        const me = this;
        
        window.google.maps.event.addListener(this.map, 'idle', function () {
            if (me.map === null || me.map.getCenter() === undefined)
                return;
            me.saveMapOptsToLocalStorage();
        });

        // Listen for new map settings
        window.addEventListener('newMapOpts', (e) => {
            this.mapOpts = e.detail;
            this.map.setMapTypeId(this.mapOpts.mapTypeId);
        })

    }

    // INIT AIRSPACES BY TYPE
    airspaceInit() {
        this.aClass = new AirspaceLayer(this.map, 'A');
        this.bClass = new AirspaceLayer(this.map, 'B');
        this.cClass = new AirspaceLayer(this.map, 'C');
        this.dClass = new AirspaceLayer(this.map, 'D');
        this.dangerClass = new AirspaceLayer(this.map, 'DANGER');
        this.restrictedClass = new AirspaceLayer(this.map, 'RESTRICTED');
        this.prohibitedClass = new AirspaceLayer(this.map, 'PROHIBITED');

        this.mapIdle();
    }

    mapIdle() {
        let me = this;
        window.google.maps.event.addListener(this.map, 'idle', (e) => {
            me.loadAirspaces();
        });

        // Set Map in Live Map when Idle
        let evnt = new CustomEvent('mapListener', {
            detail: this.map
        });
    
        window.dispatchEvent(evnt);
    }

    setAirspacesInClass(airspaces) {
        // Update airspaces => will redraw
        this.aClass.updateAirspaces(airspaces.filter(x => x.icaoClass === IcaoClass.A));
        this.bClass.updateAirspaces(airspaces.filter(x => x.icaoClass === IcaoClass.B));
        this.cClass.updateAirspaces(airspaces.filter(x => x.icaoClass === IcaoClass.C));
        this.dClass.updateAirspaces(airspaces.filter(x => x.icaoClass === IcaoClass.D));
        this.dangerClass.updateAirspaces(airspaces.filter(x => x.type === AirspaceType.Danger));
        this.restrictedClass.updateAirspaces(airspaces.filter(x => x.type === AirspaceType.Restricted));
        this.prohibitedClass.updateAirspaces(airspaces.filter(x => x.type === AirspaceType.Prohibited));
    }

    // LOCAL STORAGE
    getMapOptsFromLocalStorage() {
        let settings = JSON.parse(localStorage.getItem('mapsettings'));

        // If mapopts is not null
        if (settings === null)
            return;
        
        // Save mapOpts in class
        this.mapOpts = settings;
        
        // send global event so layers can get settings 
        let ev = new CustomEvent('newMapOpts', {
            detail: settings
        });
        window.dispatchEvent(ev);
    }

    saveMapOptsToLocalStorage() {
        if (this.map === null || this.map === undefined)
            return;

        // Get actual position and convert it to the correct format
        let center = this.map.getCenter();
        
        if (center === undefined || center === null)
            return;
        
        let mapTypeId = this.map.mapTypeId;
        let latlng = {
            lat: center.lat().toFixed(6) * 1,
            lng: center.lng().toFixed(6) * 1
        }

        let mapOpts = this.mapOpts;
        // Store info on localStorage as an obj
        mapOpts.zoom = this.map.getZoom()
        mapOpts.center = latlng;
        mapOpts.mapTypeId = mapTypeId;

        // NOW SETTINGS SAVE FROM SETTINGS DIALOG

        localStorage.setItem('mapsettings', JSON.stringify(mapOpts));
    }

    static getFrameTxt(map) {
        console.log(map)
        let bounds = map.getBounds();
        
        let p = 100;
        
        let minLat = Math.floor(bounds.getSouthWest().lat() * p) / p;
        let minLon = Math.floor(bounds.getSouthWest().lng() * p) / p;
        
        let maxLat = Math.ceil(bounds.getNorthEast().lat() * p) / p;
        let maxLon = Math.ceil(bounds.getNorthEast().lng() * p) / p;

        let frame = `${minLat},${minLon},${maxLat},${maxLon}`;
        return frame;
    }
}
